export default __webpack_public_path__ + "static/media/TickDisable.3da90823.svg";